// removed by extract-text-webpack-plugin
module.exports = {"button":"gWZGh5F6Ms0WVP-V94PnQ","icon":"_1gLYV1EY0fwgOo99eVezLI","icon_default":"_25DNeK5rbKeuv1FPG0RyCt","icon_blackRed":"_1rXifni7Py_qnZUSRE7Wps","label":"_36E6I7dwy0ZMpenbKpze7O","label_default":"_3FQpkLFGrBJJNbrHSJIilY","label_blackRed":"ul3_p0Ca8KzMEA5Px5K_0","icon_red":"F3djv5dc8wd2tetJKBS_O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/roundIconButton/roundIconButton.css
// module id = 497
// module chunks = 0